export const links = [
  { id: 1, name: "iForge", href: "https://innovatorsforge.com" },
  { id: 2, name: "Online Store", href: "https://store.innovatorsforge.com" },
//   { id: 3, name: "Maker Store", href: "/maintenance" },
  { id: 5, name: "iForge Academy", href: "https://academy.innovatorsforge.com/auth/sign-in" },
  { id: 4, name: "Link Tree", href: "https://linktr.ee/innovatorsforge" },

];
export const nftCategories = [
  { id: 1, name: "All NFTs", href: "/collections" },
  { id: 2, name: "Art", href: "/collections" },
  { id: 3, name: "Music", href: "/collections" },
  { id: 4, name: "Domain Names", href: "/collections" },
  { id: 5, name: "Collectibles", href: "/collections" },
  { id: 6, name: "Virtual World", href: "/collections" },
];
export const menuItems = [
  { id: 1, name: "Help Center", href: "https://innovatorsforge.com/help-center" },
  { id: 2, name: "About Us", href: "https://innovatorsforge.com/about" },
  { id: 3, name: "Contact Us", href: "https://innovatorsforge.com/contact" },
  { id: 4, name: "Our Blog", href: "https://innovatorsforge.com/blog" },
  // { id: 5, name: "FAQ", href: "/about" },
];
